import { AdditionalFilterItem } from '@/common/filters/types'

export const additionalFilters: AdditionalFilterItem[] = [
  { id: 'id', label: 'ID' },
]
